<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center pb-16 mb-16">
        <v-flex xs12 md9 sm11>
          <h3 class="text-center">Home-Based HealthCare for <code>{{ client.name }}</code></h3>
          <v-card class="elevation-24">
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              <invoices-button :href="'/home-based-care/' + home_based_care.id + '/invoices'"></invoices-button>
              <v-btn small text class="orange--text" v-if="canEdit" @click.stop.prevent="goTo('/home-based-care/' + home_based_care.id + '/edit')" :href="'/home-based-care/' + home_based_care.id + '/edit'" outlined>
                <v-icon left>mdi-clipboard-list-outline</v-icon>Edit
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div class="homebased">
                <div>
                  <b>Patient's Name: </b>
                  <p v-html="client.name"></p>
                </div>
                <div>
                  <b>Patient History</b>
                  <p v-html="home_based_care.history"></p>
                </div>
                <div>
                  <b>History of presenting illness / condition</b>
                  <p v-html="home_based_care.history_details"></p>
                </div>
                <div>
                  <b>Condition of Patient</b>
                  <p v-html="home_based_care.condition"></p>
                </div>
                <div>
                  <b>Special Instruction</b>
                  <p v-html="home_based_care.special_instruction"></p>
                </div>
                <div>
                  <b>Duration of Care Needed</b>
                  <p v-html="home_based_care.duration_of_care_needed"></p>
                </div>
                <div>
                  <b>Assessment Report</b>
                  <p v-html="home_based_care.report"></p>
                </div>
                <h4>Care Plan Guide</h4>
                <div>
                  <b>Nursing Diagnosis</b>
                  <p v-html="home_based_care.nursing_diagnosis"></p>
                </div>
                <div>
                  <b>Overall Objective</b>
                  <p v-html="home_based_care.overall_objective"></p>
                </div>
                <div>
                  <b>Goals</b>
                  <p v-html="home_based_care.goals"></p>
                </div>
                <div>
                  <b>Interventions</b>
                  <p v-html="home_based_care.interventions"></p>
                </div>
                <div>
                  <b>Evaluation / Review</b>
                  <p v-html="home_based_care.evaluation"></p>
                </div>
                <div>
                  <b>Provider Name</b>
                  <p v-html="professional.name"></p>
                </div>
                <h4 id="notes">HOMECARE NOTES</h4>
                <div v-for="note in notes" :key="note.id" class="pa-2">
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card :href="route('home-based-care.home-based-care-notes.show', [home_based_care.id, note.id])" @click.stop.prevent="goTo(route('home-based-care.home-based-care-notes.show', [home_based_care.id, note.id]))">
                        <v-card-title class="py-0">
                          <v-spacer></v-spacer>
                          Date: {{ note.date }}
                        </v-card-title>
                        <v-card-text class="py-0">
                          <p v-html="note.details" class="homebased-note"></p>
                        </v-card-text>
                        <v-card-actions class="py-0" v-if="note.professional">
                          <v-spacer></v-spacer>
                          Provider Name: {{ note.professional.name }}
                        </v-card-actions>
                        <v-fade-transition>
                          <v-overlay
                            v-show="hover"
                            absolute
                            color="rgb(71 18 88 / 97%)"
                          >
                            <v-btn small>Read Note</v-btn>
                          </v-overlay>
                        </v-fade-transition>
                      </v-card>
                    </template>
                  </v-hover>
                </div>
                <div v-for="i in 2" :key="i + Math.random()">
                  <v-btn small text title="Add new HomeCare notes" @click="goTo('/home-based-care/' + home_based_care.id + '/home-based-care-notes/create')">Add <span style="visibility: hidden;">... ... ... ... ...</span></v-btn><br v-if="i != 2">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="addNote">
        <template #title>Add Note</template>
        <create-note :home-based-care="home_based_care"></create-note>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const CreateNote =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "home-based-notes" */ '@/Components/HomeBasedNote/create')

  export default {
    name: 'ShowHomeBasedCare',
    layout,
    props: [
      'home_based_care', 'canEdit', 'notes'
    ],
    components: {
      MkDialog,
      CreateNote,
    },
    metaInfo () {
      return {
        title: 'View Home-Based Healthcare',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        addNote: false,
      }
    },
    methods: {
      //
    },
    computed: {
      client () {
        return this.home_based_care.client
      },
      professional () {
        return this.home_based_care.professional
      }
    },
  }
</script>

<style>
  .homebased > :nth-child(even) {
    border-top: 1px solid;
    border-bottom: 1px solid;
  }
  .homebased > h4 {
    border: none !important;
  }
  .homebased-note {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
